export function getColorFromStatusLabel(status, internalState) {
    if (status === "draft")
        return "black";
    else if (status === "open")
        return "black";
    else if (status === "assigned")
        return "red";
    else if (isInterventionTerminated(status, internalState))
        return "green";
    else if (status === "performed") {
        if (internalState === "started")
            return "blue";
        else if (internalState === "paused")
            return "red";
        else
            return "black"
    } else
        return "black";
}

export function disabledIntervention(status, internalState) {
    return status !== "performed" || !internalState || internalState !== "started";
}

export function getIconNameFromStatusLabel(status, internalState) {
    if (status === "draft")
        return "paused";
    else if (status === "open")
        return "paused";
    else if (status === "assigned")
        return "stop";
    else if (isInterventionTerminated(status, internalState))
        return "check";
    else if (status === "performed") {
        if (internalState === "started")
            return "play_arrow";
        else if (internalState === "paused")
            return "pause";
        else
            return "stop"
    } else
        return "paused";
}

export function formatStatus(status, internalStatus) {
    if (status === "draft")
        return "Brouillon";
    else if (status === "open")
        return "Ouvert";
    else if (status === "assigned")
        return "Affecté";
    else if (status === "performed") {
        if (internalStatus === "started")
            return "Démarré";
        else if (internalStatus === "paused")
            return "Interrompu";
        else if (internalStatus === "validated-report")
            return "Partiellement validé";
        else
            return "En intervention"
    } else if (status === "job_finished")
        return "Terminée";
    else if (status === "cna_validation")
        return "Terminée";
    else if (status === "done")
        return "Terminée";
    else if (status === "report_generated")
        return "Terminée";
    else if (status === "tech_report_integrated")
        return "Terminée";
    else if (status === "report_sent")
        return "Terminée";
    else if (status === "waiting_for_invoice")
        return "Terminée";
    else if (status === "closed")
        return "Clôturé";
    else if (status === "cancelled")
        return "Annulé";

    return status;
}

export function getStateColor(status, internalStatus) {
    if (status === "draft")
        return "";
    else if (status === "open")
        return "";
    else if (status === "assigned")
        return "waiting-status-color";
    else if (status === "performed") {
        if (internalStatus === "started")
            return "in-progress-status-color";
        else if (internalStatus === "paused")
            return "paused-status-color";
        else if (internalStatus === "report-validated")
            return "ok-status-color";
    } else if (isInterventionTerminated(status, internalStatus))
        return "ok-status-color";
    else if (status === "cancelled")
        return "";

    return status;
}

export function isInterventionTerminated(state, internalState) {
    return state === "job_finished" || state === "done" || state === "report_sent"
        || state === "waiting_for_invoice" || state === "closed" || state === "tech_report_integrated"
        || state === "report_generated" || (state === "performed" && internalState === "validated-report")
        || state === "cna_validation";
}